module.exports = __webpack_public_path__ + "img/co.2c3ecb76.svg";